export const DEFAULT_FORNITORE = {
    "persona_fisica": {},
    "partita_iva": {
        "denominazione": "Studio Tributario Societario",
        "comune_sede": "Milano",
        "provincia_sede": "MI",
        "indirizzo_sede": "Via Bandello 5",
        "cap_sede": "20123",
        "comune_domicilio": "Milano",
        "provincia_domicilio": "MI",
        "indirizzo_domicilio": "Via Bandello 5",
        "cap_domicilio": "20123"
    },
    "codice_fiscale": "06447960961",
    "flag_origine": "E"
};